module.exports = __webpack_public_path__ + "static/media/managers-08.5dda7df0.png";